export const OtpReason: any = {
    login: 'rGfBwE6BqVccHVQ3HzezR',
    cashout: 'vV340tz9VjIOZX7ylfnL',
    card_update: '1iC6P2dkyMYxrsY4AYzl',
    prizeout: 'BPfm09I7CagRHZaLLKkn',
};
